import React from 'react';

const WhatsNewModalIcon = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.4'
        d='M15.9974 29.3327C23.3612 29.3327 29.3307 23.3631 29.3307 15.9993C29.3307 8.63555 23.3612 2.66602 15.9974 2.66602C8.6336 2.66602 2.66406 8.63555 2.66406 15.9993C2.66406 23.3631 8.6336 29.3327 15.9974 29.3327Z'
        fill='white'
      />
      <path
        d='M17.4099 16.0005L20.4766 12.9338C20.8632 12.5471 20.8632 11.9071 20.4766 11.5205C20.0899 11.1338 19.4499 11.1338 19.0632 11.5205L15.9966 14.5871L12.9299 11.5205C12.5432 11.1338 11.9032 11.1338 11.5166 11.5205C11.1299 11.9071 11.1299 12.5471 11.5166 12.9338L14.5832 16.0005L11.5166 19.0671C11.1299 19.4538 11.1299 20.0938 11.5166 20.4805C11.7166 20.6805 11.9699 20.7738 12.2232 20.7738C12.4766 20.7738 12.7299 20.6805 12.9299 20.4805L15.9966 17.4138L19.0632 20.4805C19.2632 20.6805 19.5166 20.7738 19.7699 20.7738C20.0232 20.7738 20.2766 20.6805 20.4766 20.4805C20.8632 20.0938 20.8632 19.4538 20.4766 19.0671L17.4099 16.0005Z'
        fill='#232222'
      />
    </svg>
  );
};

export default WhatsNewModalIcon;
